<template>
    <div class="ctIi18n">
        <template v-if="title.indexOf('%s') >= 0">
            <span v-for="(item, idx) of listI18n" :key="idx">
                {{ item.name }}
                <slot :name="`i18n-${item.index}`" />
            </span>
        </template>
        <template v-else>
            {{ title }}
        </template>
    </div>
</template>

<script>
export default {
    name: 'CtLangText',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    computed: {
        listI18n() {
            let list = [];
            let row = this.title.split('%s');
            let sum = 1;
            row.forEach(element => {
                list.push({
                    name: element,
                    index: sum,
                    showSlot: true
                });
                sum++;
            });
            return list;
        }
    },

    methods: {}
};
</script>

<style lang="scss">
.ctIi18n {
    display: inline-block;
}
</style>
